// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Elup3","buttons":"Footer_buttons__1GC6T"};